<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

const props = defineProps<{
	name: string
	class?: HTMLAttributes['class']
}>()
</script>

<template>
	<div
		:class="cn('bg-[var(--avatar-background)] flex items-center justify-center h-full w-full rounded-full text-[var(--avatar-foreground)]', props.class)"
		:style="{ '--avatar-background': '#FFEBCC', '--avatar-foreground': '#EFB11D' }"
	>
		<strong>{{ props.name.slice(0, 2).toUpperCase() }}</strong>
	</div>
</template>
